export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["分"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["购买"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["用"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["活动"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["广告链接"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["做市商ID"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["描述"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["超时"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["创建日期"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["我将支付"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["我将收到"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["交易限额"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["全部"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["交易"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["报价ID"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["汇率"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["选择账户"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["超出限额"])}
}